module.exports = __webpack_public_path__ + "img/treefriends.4542e05f.jpg";